/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 *
 * @export
 * @interface MktuClassShort
 */
export interface MktuClassShort {
  /**
   * Номер класса МКТУ (от 1 до 45)
   * @type {number}
   * @memberof MktuClassShort
   */
  classNum: number
  /**
   * Наименование товара/услуги
   * @type {string}
   * @memberof MktuClassShort
   */
  text: string
}

/**
 * Check if a given object implements the MktuClassShort interface.
 */
export function instanceOfMktuClassShort(
  value: object
): value is MktuClassShort {
  if (!('classNum' in value) || value['classNum'] === undefined) return false
  if (!('text' in value) || value['text'] === undefined) return false
  return true
}

export function MktuClassShortFromJSON(json: any): MktuClassShort {
  return MktuClassShortFromJSONTyped(json, false)
}

export function MktuClassShortFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): MktuClassShort {
  if (json == null) {
    return json
  }
  return {
    classNum: json['classNum'],
    text: json['text'],
  }
}

export function MktuClassShortToJSON(value?: MktuClassShort | null): any {
  if (value == null) {
    return value
  }
  return {
    classNum: value['classNum'],
    text: value['text'],
  }
}
